import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AsyncReduxState, initialAsyncReduxState } from '../../../redux/@config/AsyncReduxState'
import { Absence } from '../../entities/Absence/Absence'

export type AbsencesState = AsyncReduxState<{
    absences: Absence[];
}>;

const initialState: AbsencesState = {
    ...initialAsyncReduxState,
    absences: [],
}

export const absencesSlice = createSlice({
    name: 'leaveOfAbsencesReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): AbsencesState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): AbsencesState {
            return {
                ...state,
                isSuccessful: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): AbsencesState {
            return {
                ...state,
                error: action.payload,
            }
        },
        setLeaveOfAbsences(state, action: PayloadAction<Absence[]>): AbsencesState {
            return {
                ...state,
                absences: action.payload,
            }
        },
    },
})

export const {
    setIsLoading,
    setIsSuccessful,
    setError,
    setLeaveOfAbsences,
} = absencesSlice.actions

export default absencesSlice.reducer
